// extracted by mini-css-extract-plugin
module.exports = {"main":"constructor-page_main__34Uax"};